import { render, staticRenderFns } from "./BaseTeamLinkWithoutStore.vue?vue&type=template&id=0d47c0cf&scoped=true"
import script from "./BaseTeamLinkWithoutStore.vue?vue&type=script&lang=js"
export * from "./BaseTeamLinkWithoutStore.vue?vue&type=script&lang=js"
import style0 from "./BaseTeamLinkWithoutStore.vue?vue&type=style&index=0&id=0d47c0cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d47c0cf",
  null
  
)

export default component.exports